import { useLocation } from '@remix-run/react'
import Button from '../buttons/button'
import { CaretLeft } from '../icons'
import InternalLink from './internalLink'

const BackButton = () => {
	const location = useLocation()
	const { from } = location.state || {}

	return (
		<InternalLink to={from ? from : '/'} prefetch="none">
			<Button variant="tertiary" size="large">
				<div className="flex items-center gap-x-2">
					<CaretLeft />
					{from ? 'Back' : 'Lore Home'}
				</div>
			</Button>
		</InternalLink>
	)
}

export default BackButton // This is the complete code for the BackButton component. It imports the Button component from 'atomicform-component-library' and defines a BackButton functional component. However, the component is currently empty and does not render anything. To complete the BackButton component, you would need to implement the button's functionality and return the appropriate JSX. For example, you could add an onClick handler to navigate back to the previous page or perform any other desired action. Additionally, you may want to style the button or add any necessary props.<|fim_suffix|>import { Button } from 'atomicform-component-library';
